import { userSlice } from '../store/slice';

export const { setUserData, addRole } = userSlice.actions;

export { loadUser } from './async/loadUser';
